module.exports = __webpack_public_path__ + "img/chinaMap.2978979e.jpg";